module.exports = __webpack_public_path__ + "img/零售-马克杯.ae332ca5.jpg";